import { cva } from 'class-variance-authority';
export const imageUploadStyling = cva('relative flex flex-col items-center justify-center gap-stack-tight border-2 border-dashed hover:bg-bg-subtle group transition-colors cursor-pointer focus:outline-none focus:ring-2 focus:ring-border-focus', {
    variants: {
        size: {
            sm: 'sm:size-16 p-stack-tight',
            md: 'size-24 p-stack-roomy',
            lg: 'size-32 p-stack-roomy',
        },
        rounding: {
            sm: 'rounded-surface',
            md: 'rounded-card-sm',
            lg: 'rounded-card',
            xl: 'rounded-[32px]',
            full: 'rounded-pill',
        },
        _error: {
            true: 'border-danger focus:ring-danger',
            false: 'border-border',
        },
    },
    defaultVariants: {
        size: 'md',
        rounding: 'lg',
        _error: false,
    },
});
export const imagePreviewStyling = cva('w-full h-full object-cover rounded-control', {
    variants: {
        size: {
            sm: '',
            md: '',
            lg: '',
            xl: '',
        },
    },
    defaultVariants: {
        size: 'md',
    },
});
export const placeholderStyling = cva('p-stack-roomy bg-bg-subtle text-fg-subtle rounded-card-sm group-hover:bg-brand-hover group-hover:text-fg-inverse transition-colors', {
    variants: {
        size: {
            sm: 'p-stack-tight',
            md: 'p-stack-roomy',
            lg: 'p-stack-roomy',
            xl: 'p-stack-section',
        },
    },
    defaultVariants: {
        size: 'md',
    },
});
export const iconStyling = cva('', {
    variants: {
        size: {
            sm: 'size-4',
            md: 'size-6',
            lg: 'size-8',
            xl: 'size-10',
        },
    },
    defaultVariants: {
        size: 'md',
    },
});
export const removeBtnStyling = cva('rounded-control p-stack-tight bg-danger hover:bg-danger-hover absolute bottom-0 right-0 translate-x-2 translate-y-2 z-10', {
    variants: {
        size: {
            sm: 'p-stack-dense',
            md: 'p-stack-tight',
            lg: 'p-stack-tight',
            xl: 'p-stack-tight',
        },
    },
    defaultVariants: {
        size: 'md',
    },
});
export const removeIconStyling = cva('text-fg-inverse', {
    variants: {
        size: {
            sm: 'size-3',
            md: 'size-3.5',
            lg: 'size-4',
            xl: 'size-5',
        },
    },
    defaultVariants: {
        size: 'md',
    },
});
